import React, { useEffect } from "react";
import {
  Home,
  Calendar,
  Video,
  Settings,
  LogOut,
  Menu,
  Users,
  LogIn,
  FileText,
  BarChart3,
  Shield,
} from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const nav = [
  { icon: <Home size={22} />, label: "Home", to: "/" },
  { icon: <Calendar size={22} />, label: "Calendar", to: "/calendar" },
  // { icon: <Video size={22} />, label: "Meeting", to: "/pre-meeting" },
  // { icon: <FileText size={22} />, label: "Notes", to: "/notes" },
  // { icon: <BarChart3 size={22} />, label: "Analytics", to: "/analytics" },
  { icon: <Users size={22} />, label: "Community", to: "/community" },
  // { icon: <Settings size={22} />, label: "Settings", to: "/settings" },
  { icon: <Shield size={22} />, label: "Admin Portal", to: "/admin" },
  // { icon: <LogIn size={22} />, label: "Login Screen", to: "/login" },
];

const SIDEBAR_COLLAPSED_KEY = "sidebar-collapsed";

interface SidebarProps {
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, setCollapsed }) => {
  useEffect(() => {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    if (stored === "true") setCollapsed(true);
    if (stored === "false") setCollapsed(false);
  }, [setCollapsed]);

  const handleToggle = () => {
    setCollapsed(!collapsed);
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(!collapsed));
  };

  const navigate = useNavigate();
    const { logout, user } = useAuth();


      const handleLogout = () => {
    logout();           // clear user and token
    navigate("/login"); // redirect to login page
  };

  const filteredNav = nav.filter((item) => {
  // Hide "Admin Portal" if user is not admin
  if (item.label === "Admin Portal" && !user?.isAdmin) return false;
  return true;
});

  return (
    <>
      <aside
        className={`fixed left-0 top-0 h-screen z-30 flex flex-col items-center overflow-y-auto bg-gradient-to-b from-[#181824] to-[#232336] ${
          collapsed ? "w-20" : "w-20 md:w-56"
        } py-8 px-2 md:px-4 shadow-lg transition-all duration-200`}
      >
        {/* Logo */}
        <div className="mb-6 flex flex-col items-center w-full">
          <img
            src="/Vela-Icon.png"
            alt="Vela Logo"
            className="w-20 h-20 object-contain mb-2"
          />
        </div>
        {/* Collapse/Expand Button - Below Logo */}
        <button
          className={`mb-8 hidden md:flex items-center justify-center transition group`}
          onClick={handleToggle}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <Menu
            size={24}
            className={`text-white/80 group-hover:text-white transition-transform ${
              collapsed ? "" : "rotate-90"
            }`}
          />
        </button>
        {/* Nav */}
        <nav className="flex-1 w-full flex flex-col gap-3 mt-2">
          {filteredNav.map((item, i) => (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) =>
                `${
                  collapsed ? "flex justify-center" : "flex items-center gap-3"
                } w-full px-4 py-3 rounded-xl text-white/80 hover:bg-white/10 transition ${
                  isActive ? "bg-white/10 text-white" : ""
                }`
              }
              end={item.to === "/"}
            >
              <span>{item.icon}</span>
              <span
                className={`${
                  collapsed ? "hidden" : "hidden md:inline"
                } text-base font-medium`}
              >
                {item.label}
              </span>
            </NavLink>
          ))}
        </nav>
        {/* Log Out */}
        {/* <button
          className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-red-400 hover:bg-red-900/30 transition mt-2"
          onClick={handleLogout}
        >
          <LogOut size={22} />
          <span
            className={`${
              collapsed ? "hidden" : "hidden md:inline"
            } text-base font-medium`}
          >
            Log Out
          </span>
        </button> */}
      </aside>
    </>
  );
};

export default Sidebar;
